import { render, staticRenderFns } from "./cSection.vue?vue&type=template&id=65549f37&"
import script from "./cSection.vue?vue&type=script&lang=js&"
export * from "./cSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports